<template>
  <div class="list_wrap list_wrap_renew">
    <ul class="list">
      <li>
        <div class="list_title">신청일</div>
        <div class="list_cont">
          {{ appliedDate }}
        </div>
      </li>
      <li>
        <div class="list_title">팩 이름</div>
        <div class="list_cont">
          {{ packName }}
        </div>
      </li>
      <li v-if="billingPeriod">
        <div class="list_title">정기 구매 기간</div>
        <div class="list_cont">{{ billingPeriod }}</div>
      </li>
      <li v-if="billingDate">
        <div class="list_title">정기 결제일</div>
        <div class="list_cont">{{ billingDate }}일</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "CompleteApplicationInfoDetail",
  props: {
    appliedDate: {
      type: String,
      default: "2020-02-20",
    },
    packName: {
      type: String,
      default: "이름을 정해주세요...",
    },
    billingDate: {
      type: String,
      default: "",
    },
    billingPeriod: {
      type: String,
      default: "",
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/composition/complete/partial/CompleteApplicationInfoDetail.vue